/* eslint-disable no-empty-pattern */
import { instance } from "@/config/index.js";

const actions = {
  listScheduledMessages({}, params) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .get(`/workspaces/${workspaceId}/scheduled-messages${params || ""}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  fetchOneScheduledMessage({}, scheduledMessageId) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .get(`/workspaces/${workspaceId}/scheduled-messages/${scheduledMessageId}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  createScheduledMessage({}, payload) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .post(`/workspaces/${workspaceId}/scheduled-messages`, payload)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  updateScheduledMessage({}, { id, payload }) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .put(`/workspaces/${workspaceId}/scheduled-messages/${id}`, payload)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  cancelScheduledMessage({}, scheduledMessageId) {
    const workspaceId = localStorage.getItem("currentWorkspace");

    return new Promise((resolve, reject) => {
      instance()
        .post(`/workspaces/${workspaceId}/scheduled-messages/${scheduledMessageId}/cancel`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
};

export default {
  namespaced: true,
  actions,
};
